// Overlay governance — only one overlay/modal open at a time.
// Each opener calls unplatedCloseOverlays('<id>') before opening itself; this
// closes the sidebar/search/popup directly and broadcasts an event so overlays
// owned by other scripts (e.g. the quick-add drawer) can close themselves too.
window.unplatedCloseOverlays = function unplatedCloseOverlays(exceptId) {
  const sidebarEl = document.getElementById('sidebar');
  const sidebarOverlayEl = document.getElementById('sidebarOverlay');
  if (exceptId !== 'sidebar' && sidebarEl && sidebarEl.classList.contains('open')) {
    sidebarEl.classList.remove('open');
    sidebarEl.setAttribute('aria-hidden', 'true');
    if (sidebarOverlayEl) sidebarOverlayEl.classList.remove('open');
    document.body.style.overflow = '';
  }
  const searchOverlayEl = document.getElementById('searchOverlay');
  if (exceptId !== 'search' && searchOverlayEl && searchOverlayEl.classList.contains('open')) {
    searchOverlayEl.classList.remove('open');
    document.body.style.overflow = '';
  }
  const popupOverlayEl = document.getElementById('popupOverlay');
  if (exceptId !== 'popup' && popupOverlayEl && popupOverlayEl.classList.contains('open')) {
    popupOverlayEl.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.dispatchEvent(new CustomEvent('unplated:closeOverlays', { detail: { except: exceptId } }));
};

// Sticky header transitions — header stays pinned through all scroll activity;
// only the "scrolled" state (announce-bar-offset collapse / solid background
// for transparent headers) still reacts to scroll position.
const headerWrap = document.getElementById('headerWrap');

if (headerWrap) {
  window.addEventListener('scroll', () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const isScrolled = scrollTop > 20;
    headerWrap.classList.toggle('scrolled', isScrolled);

    if (headerWrap.classList.contains('transparent')) {
      headerWrap.classList.toggle('header--solid', isScrolled);
    }
  }, { passive: true });
}

// Profile dropdown
const profileBtn = document.getElementById('profileBtn');
const profileDropdown = document.getElementById('profileDropdown');

if (profileBtn && profileDropdown) {
  profileBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    profileDropdown.classList.toggle('show');
  });

  window.addEventListener('click', () => {
    if (profileDropdown.classList.contains('show')) {
      profileDropdown.classList.remove('show');
    }
  });

  profileDropdown.addEventListener('click', (e) => e.stopPropagation());
}

// Mobile sidebar – accordion style
const sidebar = document.getElementById('sidebar');
const sidebarOverlay = document.getElementById('sidebarOverlay');
const sidebarBtn = document.getElementById('sidebarBtn');
const sidebarClose = document.getElementById('sidebarClose');

const openSidebar = () => {
  window.unplatedCloseOverlays('sidebar');
  sidebar.classList.add('open');
  sidebar.removeAttribute('aria-hidden');
  sidebarOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
};
const closeSidebar = () => {
  sidebar.classList.remove('open');
  sidebar.setAttribute('aria-hidden', 'true');
  sidebarOverlay.classList.remove('open');
  document.body.style.overflow = '';
};

if (sidebarBtn)     sidebarBtn.addEventListener('click', openSidebar);
if (sidebarClose)   sidebarClose.addEventListener('click', closeSidebar);
if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);

// Sidebar accordions — generic handler, works for any .sidebar-acc-btn
document.querySelectorAll('.sidebar-acc-btn').forEach(btn => {
  const body = btn.nextElementSibling;
  if (!body || !body.classList.contains('sidebar-acc-body')) return;
  btn.addEventListener('click', () => {
    const isOpen = body.classList.contains('open');
    body.classList.toggle('open');
    btn.setAttribute('aria-expanded', String(!isOpen));
  });
});


// Search
const searchBtn = document.getElementById('searchBtn');
const searchOverlay = document.getElementById('searchOverlay');
const searchClose = document.getElementById('searchClose');
const searchInput = document.getElementById('searchInput');
if (searchBtn && searchOverlay && searchClose && searchInput) {
  searchBtn.addEventListener('click', () => {
    window.unplatedCloseOverlays('search');
    searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput.focus(), 100);
  });
  const closeSearch = () => {
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  searchClose.addEventListener('click', closeSearch);
  searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) closeSearch();
  });
}

// Esc key handling
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    window.unplatedCloseOverlays(null);
    const dropdown = document.getElementById('dropdown');
    if (dropdown) dropdown.classList.remove('open');
  }
});

// Theme toggle
const themeToggle = document.getElementById('themeToggle');
if (themeToggle) {
  themeToggle.addEventListener('click', () => {
    const html = document.documentElement;
    html.dataset.theme = html.dataset.theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('theme', html.dataset.theme);
  });
}

// Initialize theme from localStorage
const savedTheme = localStorage.getItem('theme');
if (savedTheme) {
  document.documentElement.dataset.theme = savedTheme;
}

// Cupcake popup
const cupcakeBtn = document.getElementById('cupcakeBtn');
const popupOverlay = document.getElementById('popupOverlay');
const popupClose = document.getElementById('popupClose');
if (cupcakeBtn && popupOverlay && popupClose) {
  cupcakeBtn.addEventListener('click', () => {
    window.unplatedCloseOverlays('popup');
    popupOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  const closePopup = () => {
    popupOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  popupClose.addEventListener('click', closePopup);
  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) closePopup();
  });
}

// Back to top
const backToTop = document.getElementById('backToTop');
if (backToTop) {
  backToTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
